"use client";
import { ProcessedCourse } from "@/common/course/types";
import { Card } from "@/components/ui/card";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";

interface InstructorsProps {
  course: ProcessedCourse;
  instructors?: {
    data?: {
      profileImageUrl?: string;
      name?: string;
      description?: string;
      schoolImageUrl?: string;
    }[];
  };
}

export default function Instructors({ course, instructors }: InstructorsProps) {
  const t = useTranslations("Common");
  const tCourse = useTranslations("Course");
  const instructorData = instructors?.data || [];

  return (
    <section id="instructors" className="scroll-mt-[5rem] p-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 text-foreground">
          {instructorData.length === 1
            ? tCourse("meetYourInstructor")
            : tCourse("meetYourInstructors")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {instructorData.map((instructor, index) => (
            <Card
              key={index}
              className="pb-8 pt-2 px-2 flex flex-row items-center gap-6 shadow-none"
            >
              {instructor.profileImageUrl && (
                <div className="relative w-24 h-24 flex-shrink-0">
                  <Image
                    src={instructor.profileImageUrl}
                    alt={instructor.name || t("instructorAlt")}
                    fill
                    className="rounded-full object-cover"
                  />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h2 className="text-2xl font-semibold text-foreground mb-2">
                  {instructor.name || t("instructorNameFallback")}
                </h2>
                <p className="text-base text-muted-foreground mb-1">
                  {instructor.description || t("instructorDescriptionFallback")}
                </p>
              </div>
              {instructor.schoolImageUrl && (
                <div className="flex-shrink-0">
                  <Image
                    src={instructor.schoolImageUrl}
                    alt={t("schoolLogoAlt")}
                    width={80}
                    height={40}
                    className="object-contain"
                  />
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
